import { create } from "zustand";
import { SaveStatus } from "../pages/builder/_components/SavingIndicator";

type SaveStatusState = {
  status: SaveStatus;
  setStatus: (status: SaveStatus) => void;
};

export const useSaveStatusStore = create<SaveStatusState>((set) => ({
  status: "idle", // default
  setStatus: (status) => set({ status }),
}));